var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashRedCircled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145,
    height: 145,
    viewBox: "0 0 145 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74264",
    "data-name": "Group 74264",
    transform: "translate(-0.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74267",
    "data-name": "Group 74267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    transform: "translate(0.264)",
    fill: "none",
    stroke: "#f91c1c",
    strokeWidth: 4,
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 72.5,
    r: 72.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 72.5,
    r: 70.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "da086273b974cb595139babd4da17772",
    d: "M211.937,108.107l-1.063,32.167a10.6,10.6,0,0,1-10.628,10.248H180.054a10.6,10.6,0,0,1-10.628-10.237l-1.063-32.177a2.658,2.658,0,1,1,5.314-.175l1.063,32.175a5.314,5.314,0,0,0,5.314,5.109h20.192a5.314,5.314,0,0,0,5.314-5.12l1.063-32.164a2.658,2.658,0,1,1,5.314.175Zm3.515-10.7a2.657,2.657,0,0,1-2.657,2.657H167.509a2.657,2.657,0,1,1,0-5.314h8.236a3.39,3.39,0,0,0,3.382-3.05,7.947,7.947,0,0,1,7.928-7.158h6.191a7.947,7.947,0,0,1,7.928,7.158,3.39,3.39,0,0,0,3.382,3.05h8.236a2.657,2.657,0,0,1,2.657,2.657Zm-31.712-2.657h12.827a8.768,8.768,0,0,1-.678-2.508,2.657,2.657,0,0,0-2.641-2.391h-6.191a2.657,2.657,0,0,0-2.641,2.391,8.772,8.772,0,0,1-.68,2.508ZM186.415,135V112.376a2.657,2.657,0,0,0-5.314,0V135.01a2.657,2.657,0,0,0,5.314,0Zm12.79,0V112.376a2.657,2.657,0,1,0-5.314,0V135.01a2.657,2.657,0,1,0,5.314,0Z",
    transform: "translate(-117.852 -44.538)",
    fill: "red",
    opacity: 0.68
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRedCircled);
export default __webpack_public_path__ + "static/media/TrashRedCircled.944390f131c6c384d904439579679097.svg";
export { ForwardRef as ReactComponent };